import { render, staticRenderFns } from "./Statusbalken.vue?vue&type=template&id=fe81024a&scoped=true&"
import script from "./Statusbalken.vue?vue&type=script&lang=js&"
export * from "./Statusbalken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe81024a",
  null
  
)

export default component.exports